import { AutomationRuleActionsEnum } from 'src/editor/shared/types/automation-rules/actions-types'

export const automationRuleActionsTitlesLocaleKeys = {
  [AutomationRuleActionsEnum.subscribe_to_campaign]:
    'entity_settings.automation_rule.action.add_campaign',
  [AutomationRuleActionsEnum.unsubscribe_from_campaign]:
    'entity_settings.automation_rule.action.remove_campaign_from_contact',
  [AutomationRuleActionsEnum.add_tag]:
    'entity_settings.automation_rule.action.add_tag',
  [AutomationRuleActionsEnum.remove_tag]:
    'entity_settings.automation_rule.action.remove_tag',
  [AutomationRuleActionsEnum.send_email]:
    'entity_settings.automation_rule.action.send_email',
  [AutomationRuleActionsEnum.send_email_to_specific_address]:
    'entity_settings.automation_rule.action.send_email_to_specific_address',
  [AutomationRuleActionsEnum.enroll_in_course]:
    'entity_settings.automation_rule.action.enroll_in_course',
  [AutomationRuleActionsEnum.revoke_access_to_course]:
    'entity_settings.automation_rule.action.revoke_access_to_course',
  [AutomationRuleActionsEnum.enroll_in_course_bundle]:
    'entity_settings.automation_rule.action.enroll_in_course_bundle',
  [AutomationRuleActionsEnum.revoke_access_to_course_bundle]:
    'entity_settings.automation_rule.action.revoke_access_to_course_bundle',
  [AutomationRuleActionsEnum.create_user]:
    'entity_settings.automation_rule.action.create_user',
  [AutomationRuleActionsEnum.send_webhook]:
    'entity_settings.automation_rule.action.send_webhook',
  [AutomationRuleActionsEnum.grant_access_to_community]:
    'entity_settings.automation_rule.action.grant_access_to_community',
  [AutomationRuleActionsEnum.revoke_access_to_community]:
    'entity_settings.automation_rule.action.revoke_access_to_community',
}

export const automationRuleActionsDescriptionLocaleKeys = {
  [AutomationRuleActionsEnum.subscribe_to_campaign]:
    'entity_settings.automation_rule.action.description.add_campaign',
  [AutomationRuleActionsEnum.unsubscribe_from_campaign]:
    'entity_settings.automation_rule.action.description.remove_campaign_from_contact',
  [AutomationRuleActionsEnum.create_user]:
    'entity_settings.automation_rule.action.description.create_user',
  [AutomationRuleActionsEnum.add_tag]:
    'entity_settings.automation_rule.action.description.add_tag',
  [AutomationRuleActionsEnum.remove_tag]:
    'entity_settings.automation_rule.action.description.remove_tag',
  [AutomationRuleActionsEnum.send_email]:
    'entity_settings.automation_rule.action.description.send_email',
  [AutomationRuleActionsEnum.send_email_to_specific_address]:
    'entity_settings.automation_rule.action.description.send_email_to_specific_address',
  [AutomationRuleActionsEnum.enroll_in_course]:
    'entity_settings.automation_rule.action.description.enroll_in_course',
  [AutomationRuleActionsEnum.revoke_access_to_course]:
    'entity_settings.automation_rule.action.description.revoke_access_to_course',
  [AutomationRuleActionsEnum.enroll_in_course_bundle]:
    'entity_settings.automation_rule.action.description.enroll_in_course_bundle',
  [AutomationRuleActionsEnum.revoke_access_to_course_bundle]:
    'entity_settings.automation_rule.action.description.revoke_access_to_course_bundle',
  [AutomationRuleActionsEnum.send_webhook]:
    'entity_settings.automation_rule.action.description.send_webhook',
  [AutomationRuleActionsEnum.grant_access_to_community]:
    'entity_settings.automation_rule.action.description.grant_access_to_community',
  [AutomationRuleActionsEnum.revoke_access_to_community]:
    'entity_settings.automation_rule.action.description.revoke_access_to_community',
}
